module.exports = __webpack_public_path__ + "img/seat-header.e4b26f4f.png";